import React from 'react';
import { From } from '../vitrual-assistant.type';
import clsx from 'clsx';

export const ChatTyping = () => {
    return (
        <li
            className={clsx({
                message: true,
                [`message_${From.ASSISTANT}`]: true,
                message_typing: true,
            })}
        >
            <div className="dot" />
            <div className="dot" />
            <div className="dot" />
        </li>
    );
};
